import { JSX } from 'react'

import Image from 'next/image'
import Blockies from 'react-blockies'
import { isAddress } from 'viem'

import { ImageWithFallback } from '~/components/ImageWithFallback'
import { ADDRESS_ZERO } from '~/constants/addresses'
import { IAddress } from '~/types'

export const Avatar = ({
  image,
  fallbackImage,
  address = ADDRESS_ZERO,
  initial,
  alt,
  size = 16,
}: {
  image?: string
  fallbackImage?: string
  address?: IAddress
  // Final fallback for non-address identities; without it the fallback is blockies
  initial?: string
  alt?: string
  size?: number
}): JSX.Element => {
  const dimension = `${size / 16}rem`

  return (
    <div
      style={{ width: dimension, height: dimension }}
      className="relative flex-shrink-0 overflow-hidden rounded-full [&>canvas]:!h-full [&>canvas]:!w-full"
    >
      {fallbackImage ? (
        <ImageWithFallback
          src={image}
          alt={alt ?? address}
          fill
          sizes={`${size}px`}
          fallbackSrc={fallbackImage}
          className="object-cover"
        />
      ) : image ? (
        <Image
          src={image}
          alt={alt ?? address}
          fill
          sizes={`${size}px`}
          className="object-cover"
        />
      ) : initial ? (
        <span
          className="flex h-full w-full items-center justify-center bg-gray-600 font-semibold text-white"
          style={{ fontSize: `${size / 32}rem` }}
        >
          {initial}
        </span>
      ) : (
        <Blockies
          seed={
            address && isAddress(address)
              ? address.toLowerCase() // Blockies canonicalizes addresses by lowercasing. Learn more here: https://claude.ai/share/d9ab79b3-acb2-481d-8921-1632312c4713
              : ADDRESS_ZERO
          }
          scale={Math.max(1, Math.ceil(size / 8))}
        />
      )}
    </div>
  )
}
